import React, { useState } from 'react';
import { MdArrowBack, MdCheckCircle, MdCameraAlt } from 'react-icons/md';

const ACCOUNTS = [
  { id: 'chequing', name: 'Chequing Account', num: '...4521', balance: '$4,231.50' },
  { id: 'savings',  name: 'Savings Account',  num: '...8802', balance: '$12,840.00' },
];

const MobileDepositScreen = ({ onNavigate, onBack }) => {
  const [step, setStep]         = useState('capture');
  const [account, setAccount]   = useState('chequing');
  const [amount, setAmount]     = useState('');
  const [frontDone, setFront]   = useState(false);
  const [backDone, setBack]     = useState(false);
  const [errors, setErrors]     = useState({});
  const [refNum]                = useState(() => 'DEP' + Math.floor(Math.random() * 9000000 + 1000000));

  const selectedAcct = ACCOUNTS.find(a => a.id === account);
  const fmt = v => `$${parseFloat(v || 0).toFixed(2)}`;

  const validate = () => {
    const e = {};
    const amt = parseFloat(amount);
    if (!amount || isNaN(amt) || amt <= 0) e.amount = 'Enter a valid cheque amount';
    if (!frontDone) e.front = 'Please capture the front of the cheque';
    if (!backDone)  e.back  = 'Please capture the back of the cheque';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const reset = () => { setStep('capture'); setAmount(''); setFront(false); setBack(false); setErrors({}); };

  if (step === 'success') return (
    <div className="screen bh-flow">
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          <h1 className="bh-flow-title">Mobile Deposit</h1>
        </div>
      </header>
      <div className="emt-success-body">
        <div className="emt-success-circle"><MdCheckCircle size={52} color="var(--td-green)" /></div>
        <div className="emt-success-title">Deposit Submitted!</div>
        <div className="emt-success-amount">{fmt(amount)}</div>
        <div className="emt-success-sub">Deposited to {selectedAcct?.name}</div>
        <div className="mob-deposit-availability">Funds available within 1–2 business days</div>
        <div className="acct-transfer-ref">Ref: {refNum}</div>
        <button className="emt-primary-btn" style={{ marginTop: 32 }} onClick={() => onNavigate('home')}>Done</button>
        <button className="emt-ghost-btn" onClick={reset}>Deposit Another</button>
      </div>
    </div>
  );

  if (step === 'review') return (
    <div className="screen bh-flow">
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          <button className="bh-flow-back" onClick={() => setStep('capture')} aria-label="Back">
            <MdArrowBack />
          </button>
          <h1 className="bh-flow-title">Review Deposit</h1>
        </div>
      </header>
      <div className="scroll-content gray-bg">
        <div className="emt-review-amount">{fmt(amount)}</div>
        <div className="emt-section">
          <div className="emt-review-row">
            <span className="emt-review-label">To Account</span>
            <span className="emt-review-value">{selectedAcct?.name}<br /><span style={{ fontSize: 11, color: 'var(--text-light)' }}>{selectedAcct?.num} · {selectedAcct?.balance}</span></span>
          </div>
          <div className="emt-review-row">
            <span className="emt-review-label">Amount</span>
            <span className="emt-review-value">{fmt(amount)} CAD</span>
          </div>
          <div className="emt-review-row">
            <span className="emt-review-label">Availability</span>
            <span className="emt-review-value">1–2 business days</span>
          </div>
          <div className="emt-review-row">
            <span className="emt-review-label">Images</span>
            <span className="emt-review-value" style={{ color: 'var(--td-green)' }}>Front & Back captured</span>
          </div>
        </div>
        <div className="emt-notice">Write "TD Mobile Deposit" on the back of the cheque. Keep it for 5 business days after confirmation.</div>
        <button className="emt-primary-btn" onClick={() => setStep('success')}>Submit Deposit</button>
        <button className="emt-ghost-btn" onClick={() => setStep('capture')}>Edit</button>
      </div>
    </div>
  );

  return (
    <div className="screen bh-flow">
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          <button className="bh-flow-back" onClick={onBack || (() => onNavigate('home'))} aria-label="Back to home">
            <MdArrowBack />
          </button>
          <h1 className="bh-flow-title">Mobile Deposit</h1>
        </div>
      </header>
      <div className="scroll-content gray-bg">

        <div className="emt-section">
          <div className="emt-section-title">Deposit To</div>
          {ACCOUNTS.map(a => (
            <div key={a.id} className={`emt-account-row${account === a.id ? ' selected' : ''}`} onClick={() => setAccount(a.id)}>
              <div className="emt-account-info">
                <div className="emt-account-name">{a.name}</div>
                <div className="emt-account-num">{a.num}</div>
              </div>
              <div className="emt-account-right">
                <div className="emt-account-balance">{a.balance}</div>
                <div className={`emt-radio${account === a.id ? ' on' : ''}`} />
              </div>
            </div>
          ))}
        </div>

        <div className="emt-section">
          <div className="emt-section-title">Cheque Amount</div>
          <div className={`emt-amount-wrapper${errors.amount ? ' error' : ''}`}>
            <span className="emt-currency-symbol">$</span>
            <input className="emt-amount-input" type="number" min="0" step="0.01" placeholder="0.00" value={amount} onChange={e => { setAmount(e.target.value); setErrors(p => ({ ...p, amount: '' })); }} />
            <span className="emt-currency-code">CAD</span>
          </div>
          {errors.amount && <div className="emt-error" style={{ marginTop: 6 }}>{errors.amount}</div>}
        </div>

        <div className="emt-section">
          <div className="emt-section-title">Capture Cheque Images</div>
          <div className="mob-deposit-capture-row">
            <div className={`mob-deposit-capture-box${frontDone ? ' done' : ''}${errors.front ? ' error' : ''}`} onClick={() => { setFront(true); setErrors(p => ({ ...p, front: '' })); }}>
              {frontDone ? <MdCheckCircle size={28} color="var(--td-green)" /> : <MdCameraAlt size={28} color="var(--text-light)" />}
              <span className="mob-deposit-capture-label">{frontDone ? 'Front Captured' : 'Tap to capture'}</span>
              <span className="mob-deposit-capture-sub">Front of cheque</span>
            </div>
            <div className={`mob-deposit-capture-box${backDone ? ' done' : ''}${errors.back ? ' error' : ''}`} onClick={() => { setBack(true); setErrors(p => ({ ...p, back: '' })); }}>
              {backDone ? <MdCheckCircle size={28} color="var(--td-green)" /> : <MdCameraAlt size={28} color="var(--text-light)" />}
              <span className="mob-deposit-capture-label">{backDone ? 'Back Captured' : 'Tap to capture'}</span>
              <span className="mob-deposit-capture-sub">Back of cheque</span>
            </div>
          </div>
          {(errors.front || errors.back) && <div className="emt-error" style={{ padding: '0 16px 8px' }}>{errors.front || errors.back}</div>}
        </div>

        <button className="emt-primary-btn" onClick={() => { if (validate()) setStep('review'); }}>Continue</button>
      </div>
    </div>
  );
};

export default MobileDepositScreen;
